const updateCartItemsWindowArr=t=>{theme.cart.getCart().then((e=>{document.dispatchEvent(new CustomEvent("cart:updated",{detail:{cart:e}})),window.cartItems=e.items,t&&t()}))};function getCart(){return fetch(window.theme.routes.cart).then((function(t){return t.json()})).then((function(t){return t})).catch((function(t){t.description||console.warn(t)}))}function setHelloRetailCartData(t){var e=t.items.map((function(t){return t.product_id}));ADDWISH_PARTNER_NS.api.cart.setCart({total:(t.total_price/100).toString(),url:window.theme.routes.cartPage,productNumbers:e.map(String),email:window.theme.customer.email??""},(function(){console.log("Cart has been tracked")}))}function setCartTracking(t){window.ADDWISH_PARTNER_NS&&(t?.detail?.cart?setHelloRetailCartData(t.detail.cart):getCart().then((function(t){setHelloRetailCartData(t)})))}document.addEventListener("cart:updated",setCartTracking),document.addEventListener("ajaxProduct:added",setCartTracking);
// document.addEventListener('DOMContentLoaded', () => {
//   function selectCustomImage() {
//     const imageWrappers = document.querySelectorAll('.product-main-slide');

//     imageWrappers.forEach(wrapper => {
//       const image = wrapper.querySelector('img');

//       if (image && image.hasAttribute('data-custom') && image.getAttribute('data-custom') === 'true') {
//         wrapper.classList.add('is-selected');
//         wrapper.style.zIndex = '10';
//       } else {
//         wrapper.classList.remove('is-selected');
//         wrapper.style.zIndex = '1';
//       }
//     });
//   }

//     function selectCustomThumb() {
//     const imageWrappers = document.querySelectorAll('.product__thumb');

//     imageWrappers.forEach(wrapper => {
//       const image = wrapper.querySelector('.product__thumb img');

//       if (image && image.hasAttribute('data-custom') && image.getAttribute('data-custom') === 'true') {
//         wrapper.classList.add('is-active');
//       } else {
//         wrapper.classList.remove('is-active');
//       }
//     });
//   }

//   function resetCustomImage() {
//     const imageWrappers = document.querySelectorAll('.product-main-slide');
//     imageWrappers.forEach(wrapper => {
//       wrapper.classList.remove('is-selected');
//       wrapper.style.zIndex = '1';
//     });
//   }
//     function resetCustomThumb() {
//     const thumbWrappers = document.querySelectorAll('.product__thumb');
//     thumbWrappers.forEach(wrapper => {
//       wrapper.classList.remove('is-active');
//     });
//     const imageWrappers = document.querySelectorAll('.product-main-slide');

//     imageWrappers.forEach(wrapper => {
//       const image = wrapper.querySelector('img');

//       if (image && image.hasAttribute('data-custom') && image.getAttribute('data-custom') === 'true') {
//         wrapper.classList.remove('is-selected');
//         wrapper.style.zIndex = '1';
//       } else {
//       }
//     });
//   }
//       function resetCustomThumbSlide() {
//     const imageWrappers = document.querySelectorAll('.product-main-slide');

//     imageWrappers.forEach(wrapper => {
//       const image = wrapper.querySelector('img');

//       if (image && image.hasAttribute('data-custom') && image.getAttribute('data-custom') === 'true') {
//         wrapper.classList.add('is-selected');
//         wrapper.style.zIndex = '10';
//       }
//     });
//   }
  
//   selectCustomImage();
//   selectCustomThumb();
  
//   document.addEventListener('click', (event) => {
//     const clickedElement = event.target;
//     if (clickedElement.closest('.variant-input img')) {
//       resetCustomImage();
//     }
//   });
//     document.addEventListener('click', (event) => {
//     const clickedElement = event.target;
//     if (clickedElement.closest('.product__thumb')) {
//        if (clickedElement.classList.contains('custom_image')) {
//          resetCustomThumbSlide();
//     } else {
//       resetCustomThumb();   
//     }
//     }
//   });
// });

$(document).ready(function () {
  const $gridProductsContainer = $('.grid');

  const insertHtmlIntoGrid = () => {
    const $gridProducts = $('.grid .grid-product');
    const $otherElements = $('#yarn-swatches .variant-colors');

    if ($otherElements.length === 0) {
      console.warn('[InsertSwatches] No swatches found. Will retry...');
      return;
    }

    $otherElements.each(function (_, element) {
      const variantTitle = $(element).data('title') || $(element).find('.variant-title').text().trim();
      if (!variantTitle) return;

      $gridProducts.each(function (_, gridElement) {
        const $titleEl = $(gridElement).find('.grid-product__title');
        const productTitle = ($titleEl.data('originalTitle') || $titleEl.text()).trim();
        //if (!productTitle || /Kit/i.test(productTitle)) return;
        if (!productTitle) return;

        const normalizedProductTitle = productTitle.toLowerCase();
        const normalizedVariantTitle = variantTitle.toLowerCase();

        if (normalizedProductTitle === normalizedVariantTitle) {
          const innerHtml = $(element).html();
          let $childElement = $(gridElement).find('.child-container');

          if ($childElement.length) {
            if ($childElement.html().indexOf(innerHtml) === -1) {
              $childElement.append(innerHtml);
              //console.log(`[InsertSwatches] Appended to existing container for: ${productTitle}`);
            }
          } else {
            $(gridElement).append(`<div class="child-container">${innerHtml}</div>`);
            //console.log(`[InsertSwatches] Created new container for: ${productTitle}`);
          }
        }
      });
    });
  };

  // Run once grid is loaded
  const observer = new MutationObserver(function (mutations) {
    const hasGridProducts = $('.grid .grid-product').length > 0;
    if (hasGridProducts) {
      //console.log('[InsertSwatches] MutationObserver triggered');

      // Wait for swatches to load in #yarn-swatches
      const waitForSwatches = setInterval(() => {
        const swatchCount = $('#yarn-swatches .variant-colors').length;
        //console.log('[InsertSwatches] Waiting for swatches. Count:', swatchCount);
        if (swatchCount > 0) {
          clearInterval(waitForSwatches);
          insertHtmlIntoGrid();
        }
      }, 300);
    }
  });

  if ($gridProductsContainer.length) {
    observer.observe($gridProductsContainer[0], {
      childList: true,
      subtree: true,
    });
  }

  // Retry on filter changes
  $(document).on('click', '.tag__checkbox, .tag--remove', function () {
    setTimeout(() => {
      //console.log('[InsertSwatches] Re-inserting after filter');
      insertHtmlIntoGrid();
    }, 4000);
  });
});



const removeAfterLastHyphen = (el) => {
  const originalText = el.textContent;
  el.dataset.originalTitle = originalText;

  const lastHyphenIndex = originalText.lastIndexOf('-');
  if (lastHyphenIndex !== -1) {
    const trimmedText = originalText.substring(0, lastHyphenIndex).trim();
    el.textContent = trimmedText;
  }
};

const processTitles = () => {
  document.querySelectorAll('.grid__item .grid-product__title').forEach(el => {
    if (!el.dataset.hyphenProcessed) {
      removeAfterLastHyphen(el);
      el.dataset.hyphenProcessed = "true";
    }
  });
};

processTitles();

const observer = new MutationObserver(() => {
  processTitles();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  function removeGoogleStars() {
    document.querySelectorAll('.google_stars').forEach(function (el) {
      el.remove();
    });
  }

  // Remove anything already present
  removeGoogleStars();

  // Remove it whenever another script adds it
  const observer = new MutationObserver(function () {
    removeGoogleStars();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();